import { createQueryKeys } from "@lukemorales/query-key-factory";

import { LONG_REQUEST_TIMEOUT_MS } from "../../client";
import type { CoreApiClient } from "../client";
import type { Meter, MeterConsumption, MeterConsumptionExportQuery, MeterConsumptionQuery } from "../types/meter.type";

export const createMeterQueries = (api: CoreApiClient) => {
  const { client, request } = api;

  const list = async (buildingId: string): Promise<Meter[]> => {
    const { data } = await request("get", "/buildings/{buildingId}/meters", { params: { path: { buildingId } } });
    return data;
  };

  const consumption = async (
    buildingId: string,
    meterId: string,
    query: MeterConsumptionQuery,
  ): Promise<MeterConsumption> => {
    const { data } = await request("get", "/buildings/{buildingId}/meters/{meterId}/consumption", {
      params: { path: { buildingId, meterId }, query },
    });
    return data;
  };

  const exportConsumption = async (
    buildingId: string,
    meterId: string,
    query: MeterConsumptionExportQuery,
  ): Promise<Blob> => {
    const { data, error } = await client.GET("/buildings/{buildingId}/meters/{meterId}/consumption/export", {
      params: { path: { buildingId, meterId }, query },
      parseAs: "blob",
      timeout: LONG_REQUEST_TIMEOUT_MS,
    });
    if (error) throw new Error(error.message);
    return data;
  };

  return {
    list,
    consumption,
    exportConsumption,
    queries: createQueryKeys("meter", {
      building: (buildingId: string) => ({
        queryKey: [buildingId],
        queryFn: () => list(buildingId),
      }),
      consumption: (buildingId: string, meterId: string, query: MeterConsumptionQuery) => ({
        queryKey: [buildingId, meterId, query],
        queryFn: () => consumption(buildingId, meterId, query),
      }),
    }),
  };
};
